export class ApiError extends Error {
  readonly code: number | null;
  readonly type: string | null;

  constructor({
    message,
    code,
    type,
  }: {
    message: string;
    code?: number | null;
    type?: string | null;
  }) {
    super(message);
    this.name = 'ApiError';
    this.code = code ?? null;
    this.type = type ?? null;
  }
}